import {Ref, computed} from 'vue';
import {PolyDictionary} from '../../../../../../@polygonjs/polygonjs/src/types/GlobalTypes';
import {AttribType, AttribClass, AttribSize} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/Constant';
import {CoreGroup} from '../../../../../../@polygonjs/polygonjs/src/core/geometry/Group';
import {attribClassClassObject, BuildHeaders, BuildTableData} from './Common';

interface SetupForObjectOptions {
	selectedAttribClass: Ref<AttribClass>;
	objectAttribNames: Ref<string[]>;
	buildHeaders: BuildHeaders;
	buildTableData: BuildTableData;
}

export function SetupForObject(options: SetupForObjectOptions) {
	const {selectedAttribClass, objectAttribNames, buildHeaders, buildTableData} = options;

	const classObjectObjectButton = computed(() => {
		return attribClassClassObject(selectedAttribClass.value == AttribClass.OBJECT);
	});
	function setAttribClassObject() {
		selectedAttribClass.value = AttribClass.OBJECT;
	}

	//
	//
	// OBJECTS
	//
	//
	function build(coreGroup: CoreGroup) {
		const attribNames = coreGroup.objectAttribNames();
		objectAttribNames.value = coreGroup.objectAttribNames();
		const attribSizesByName = coreGroup.objectAttribSizesByName();
		const _attribTypesByName = coreGroup.objectAttribTypesByName();
		const attribMaxSizeByName: PolyDictionary<AttribSize> = {};
		const attribTypeByName: PolyDictionary<AttribType> = {};
		for (const attribName of attribNames) {
			const sizes = attribSizesByName[attribName];
			const maxSize = Math.max(...sizes);
			attribMaxSizeByName[attribName] = maxSize;
			const type =
				_attribTypesByName[attribName].length > 1 ? AttribType.STRING : _attribTypesByName[attribName][0];
			attribTypeByName[attribName] = type;
		}

		buildHeaders(objectAttribNames.value, attribMaxSizeByName, attribTypeByName);
		buildTableData(coreGroup.allCoreObjects(), objectAttribNames.value, attribMaxSizeByName);
	}

	return {
		classObjectObjectButton,
		setAttribClassObject,
		build,
	};
}
